import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import {
  Circle as BulletActive,
  ExpandMoreRounded as ExpandIcon,
  LocalAtmOutlined as ChequeIcon,
} from "@mui/icons-material";
import { useSelector } from "react-redux";

export const chequeItemsConfig = [
  {
    permission: 7,
    label: "Creation of Cheque",
    to: "/cheque/chequing",
    notificationKey: "Creation of Cheque",
    notificationArrayProp: "transactions",
    isLoadingProp: "isTransactionsLoading",
    notificationValue: "pending",
  },
  {
    permission: 9,
    label: "Filing of Debit Memo",
    to: "/cheque/debiting",
  },
  {
    permission: 8,
    label: "Clearing of Cheque",
    to: "/cheque/clearing",
    notificationKey: "Clearing of Cheque",
    notificationArrayProp: "cheque",
    isLoadingProp: "isChequeLoading",
    notificationValue: "pending",
  },
  {
    permission: 40,
    label: "Cancelled Cheque",
    to: "/cheque/cancelled",
    notificationKey: "Cancelled Cheque Viewing",
    notificationArrayProp: "cheque",
    isLoadingProp: "isChequeLoading",
    notificationValue: "pending",
  },
  {
    permission: 7,
    label: "Returned/Held Cheques",
    to: "/cheque/returned-cheques",
    notificationKey: "Creation of Cheque",
    notificationArrayProp: "transactions",
    isLoadingProp: "isTransactionsLoading",
    notificationValue: "return",
  },
];

const SidebarChequeDropdown = ({
  activeDropdown,
  user,
  transactions,
  cheque,
  shouldDisplayDotNotification,
  isTransactionsLoading,
  isChequeLoading,
  RouterLink,
  DisplayBubbleNotification,
}) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/cheque/gi));
  const isNotReleasing = !Boolean(activeDropdown?.match(/issuing|releasing/gi));
  const isNotReport = !Boolean(activeDropdown?.match(/report/gi));

  const allNotifications = {
    "Creation of Cheque": transactions,
    "Clearing of Cheque": cheque,
    "Cancelled Cheque Viewing": cheque,
  };

  const allLoadingStates = {
    isTransactionsLoading,
    isChequeLoading,
  };

  return (
    <Accordion defaultExpanded={/treasury/i.test(user.role)} elevation={0} square disableGutters>
      <AccordionSummary
        className={
          isActiveDropdown && isNotReport && isNotReleasing
            ? `FstoSidebarActiveDropdown-root ${color}`
            : `FstoSidebarDropdown-root  ${color}`
        }
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <ChequeIcon />
        <Typography variant="sidebar">Cheque</Typography>
        {!isTransactionsLoading &&
        chequeItemsConfig.some(
          (item) =>
            user.permissions.includes(item.permission) &&
            item.notificationKey &&
            shouldDisplayDotNotification(
              allNotifications[item.notificationKey],
              item.notificationKey
            )
        ) ? (
          <BulletActive className="FstoSidebarActiveNotif-root" />
        ) : null}
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {chequeItemsConfig.map(
          (item) =>
            user.permissions.includes(item.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
                {item.notificationKey && !allLoadingStates[item.isLoadingProp] && (
                  <DisplayBubbleNotification
                    notificationArray={allNotifications[item.notificationKey]}
                    permission={item.notificationKey}
                    value={item.notificationValue}
                  />
                )}
              </RouterLink>
            )
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarChequeDropdown;
